export function correctVariableType(v) {
  try {
    v = JSON.parse(v);
  } catch(e) {}
  if (v === 'true') v = true;
  else if (v === 'false') v = false;
  else if (!isNaN(v) && ![true, false].includes(v)) v = parseInt(v);
  return v;
}